



function initSubscriptionDropdown() {
  var radios = document.querySelectorAll('.sp-radio');

  function updateCollapsibles() {
    radios.forEach(function (radio) {
      var card = radio.closest('.sp-card');
      if (!card) return;

      var collapsible = card.querySelector('.sp-collapsible');
      if (!collapsible) return;

      if (radio.checked) {
        collapsible.style.maxHeight = collapsible.scrollHeight + 'px';
        collapsible.style.opacity = '1';
      } else {
        collapsible.style.maxHeight = '0px';
        collapsible.style.opacity = '0';
      }
    });
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', updateCollapsibles);
  });

  updateCollapsibles();
}


(function () {

  var btnDefaultText = "+ Add";

  function refreshCartDrawer(onDone) {
    fetch('/?sections=cart-drawer')
      .then(r => r.json())
      .then(sections => {
        var html = sections['cart-drawer'];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newItems = doc.querySelector('#CartDrawer-CartItems');
        var curItems = document.querySelector('#CartDrawer-CartItems');
        if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

        var newFooter = doc.querySelector('.cart-drawer__footer');
        var curFooter = document.querySelector('.cart-drawer__footer');
        if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;

        var newBubble = doc.querySelector('.cart-count-bubble');
        var curBubble = document.querySelector('.cart-count-bubble');
        if (newBubble && curBubble) {
          curBubble.innerHTML = newBubble.innerHTML;
          curBubble.removeAttribute('hidden');
        }

        document.querySelector('cart-drawer')?.classList.remove('is-empty');
        document.querySelector('cart-drawer-items')?.classList.remove('is-empty');

        if (onDone) onDone();
      });
  }

  function addUpsellToCart(btn) {
    var variantId = parseInt(btn.dataset.variantId);

    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => {
      if (!res.ok) throw new Error();
      return res.json();
    })
    .then(() => {
      btn.textContent = '✓ Added';

      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = btnDefaultText;
      }, 2000);

      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => updateCartCountBubble(cart.item_count));

      refreshCartDrawer();
    })
    .catch(() => {
      btn.disabled = false;
      btn.textContent = btnDefaultText;
    });
  }

  /* ✅ KEY FIX: event delegation */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-upsell-add-btn');
    if (!btn) return;

    addUpsellToCart(btn);
  });

})();

initslided();

$(document).on('shopify:section:load', function(event) {
  initslided();
});

$(document).on('shopify:section:unload', function(event) {
  initslided();
});

function initslided() {
  $('.M-trustpilot-slider').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 575,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}


